<app-spinner-overlay></app-spinner-overlay>

<div class="titolo-pagina" style="padding-top: 20px">
  <div class="titolo-diag">Tematica - {{ data.domandaTematica }}</div>

  <div class="descrizione-diag">
    {{ data.descrizioneTematica }}
  </div>
</div>

<form [formGroup]="formMotivazione" appFormContainer [larghezza]="1" [gap]="10" [rowGap]="5">
  <mat-form-field
    (mousedown)="$event.stopPropagation()"
    appFormElement
    [larghezza]="5"
    [riempi]="true"
  >
    <mat-label>Motiva la tua deselezione della tematica.</mat-label>
    <textarea
      matInput
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="1"
      placeholder="Motivazione"
      formControlName="motivazioneControl"
      rows="4"
    ></textarea>
    <mat-error appFormError></mat-error>
  </mat-form-field>
</form>

<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Indietro</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="conferma()" class="primary-button">
      Conferma
    </button>
  </div>
</div>
